import R from 'ramda';
import actionTypes from '../actionTypes';

const initialState = {
  messages: [],
};

export default (state = initialState, action) => {
  let index;

  switch (action.type) {
    case actionTypes.DEAL_MESSAGES_GET_REQUEST:
    case actionTypes.DEAL_MESSAGE_SEND_REQUEST:
    case actionTypes.DEAL_MESSAGE_UPDATE_REQUEST:
      return { ...state, status: action.type };

    case actionTypes.DEAL_MESSAGES_GET_ERROR:
      return { ...initialState };

    case actionTypes.DEAL_MESSAGES_GET_SUCCESS:
      return { ...state, messages: action.messages };

    case actionTypes.DEAL_MESSAGE_SEND_ERROR:
      return {
        ...state,
        status: action.type,
        error: action.error,
        selectedMessage: null,
      };

    case actionTypes.DEAL_MESSAGE_SEND_SUCCESS:
      return {
        ...state,
        status: action.type,
        selectedMessage: action.message,
        messages: state.messages.concat(action.message),
      };

    case actionTypes.DEAL_MESSAGE_UPDATE_SUCCESS:
      index = R.findIndex(R.propEq('id', action.message.id))(state.messages);
      if (index === -1) {
        return {
          ...state,
          status: action.type,
          selectedMessage: action.message,
          messages: state.messages.concat(action.message),
        };
      } else {
        state.messages[index] = action.message;
        return {
          ...state,
          status: action.type,
          selectedMessage: action.message,
          messages: state.messages,
        };
      }

    case actionTypes.DEAL_MESSAGE_DELETE_SUCCESS:
      index = R.findIndex(R.propEq('id', parseInt(action.messageId, 10)))(
        state.messages
      );

      if (index !== -1) {
        return {
          ...state,
          status: action.type,
          selectedMessage: null,
          messages: R.remove(index, 1, state.messages),
        };
      } else {
        return { ...state, status: action.type, selectedMessage: null };
      }

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// src/redux/reducers/dealMessages.js